export const PlayIcon = () => (
  <svg width="96" height="97" viewBox="0 0 96 97" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M95 48.4552C95 74.4653 73.9556 95.5474 48 95.5474C22.0444 95.5474 1 74.4653 1 48.4552C1 22.4451 22.0444 1.36304 48 1.36304C73.9556 1.36304 95 22.4451 95 48.4552Z"
      stroke="#624DE3"
      strokeWidth="2"
    />
    <path
      d="M61.0729 47.5899C61.7386 47.975 61.7386 48.9361 61.0729 49.3211L42.2182 60.2279C41.5515 60.6135 40.7174 60.1324 40.7174 59.3622L40.7174 37.5488C40.7174 36.7786 41.5515 36.2976 42.2182 36.6832L61.0729 47.5899Z"
      fill="#624DE3"
    />
  </svg>
);
